import React, { createContext, useContext, useState, ReactNode } from 'react';

interface DebugContextType {
  isDebugMode: boolean;
  setIsDebugMode: (value: boolean) => void;
}

const DebugContext = createContext<DebugContextType | undefined>(undefined);

export const DebugProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isDebugMode, setIsDebugMode] = useState(false);

  return (
    <DebugContext.Provider value={{ isDebugMode, setIsDebugMode }}>
      {children}
    </DebugContext.Provider>
  );
};

export const useDebugMode = (): DebugContextType => {
  const context = useContext(DebugContext);
  if (context === undefined) {
    throw new Error('useDebugMode must be used within a DebugProvider');
  }
  return context;
};
